export var getAliasName = function (value) {
    console.log("getAliasName is not implemented yet in flash/utils");
    return "";
};
